import { render, staticRenderFns } from "./World.vue?vue&type=template&id=5ac8dbaa&scoped=true&"
import script from "./World.vue?vue&type=script&lang=js&"
export * from "./World.vue?vue&type=script&lang=js&"
import style0 from "./World.vue?vue&type=style&index=0&id=5ac8dbaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac8dbaa",
  null
  
)

export default component.exports